import React from "react";
import { CardBody, Card, Row, Col, Input, Label } from "reactstrap";

export default function ControlCard({
	data,
	cardClassName = "",
	heading = null,
	showCheckbox,
	checked,
	handleChange,
	label='',
	checkboxId='',
	 children
}) { 
	return (
		<Card className={`${cardClassName} shadow-none rounded-4 main-card`}>

			<CardBody className="d-flex flex-column ps-3  ">
				<Row className="row-cols-1 g-2 m-0">
					 
					{heading && (
						<Col className="mt-0">
							<h5 className="m-0 ">{heading}</h5>
						</Col>
					)}
					{children}
					{Array.isArray(data) &&
						data.length > 0 &&
						data.map((i) => (
							<Col className="card__item">
								<div className="label">{i.label}</div>
								<div className="value">{i.value}</div>
							</Col>
						))}
					{showCheckbox && (
						<Col className="d-flex gap-2 align-items-center ">
							<Input
								type="checkbox"
								checked={checked}
								onChange={handleChange}
								className="planscreen__checkbox m-0"
								id={checkboxId}
							/>
							{label && <Label className="m-0" for={checkboxId}>{label}</Label>}
						</Col>
					)}
				</Row>
			</CardBody>
		</Card>
	);
}
